module.exports = __webpack_public_path__ + "img/onboarding-calendar-galileo.680b7d94.png";